import { DatabaseEntities } from "../../../common/models/database-entities.model";


export class GrainBoxWheels extends DatabaseEntities<GrainBoxWheels> {
    value: string;
}
